import type { EthersValue } from "common/types/ethersValues"

export const formatProposalValues = (
  value: EthersValue,
  type: string,
): string => {
  if (type === "tuple[]") {
    if (Array.isArray(value)) {
      const compactString: string = value
        .map((tuple: any) => {
          return `[${tuple
            .map((entry: any) => getEntryString(entry))
            .join(", ")}]`
        })
        .join(", ")

      if (compactString.startsWith("()")) return "Unable to render value." // for when value is an empty array (or arrays) within another array

      return `[${compactString}]`
    }
  }

  if (type === "tuple") {
    if (Array.isArray(value)) {
      const formattedString = `[${value
        .map((entry: any) => getEntryString(entry))
        .join(", ")}]`

      if (formattedString.startsWith("()")) return "Unable to render value." // for when value is an empty array

      return formattedString
    }
  }

  // not a tuple[], for example bytes[]
  if (type.endsWith("[]")) {
    return `[${value}]`
  }

  return `${value}`
}

const getEntryString = (entry: any): string => {
  if (Array.isArray(entry)) {
    const formattedString = (entry as any[])
      .map((entry: any) => getEntryString(entry))
      .join(", ")

    return `[${formattedString}]`
  }

  return entry as string
}
